import React from 'react';
import { ArrowRight, ShieldCheck, Clock } from 'lucide-react';

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) element.scrollIntoView({ behavior: 'smooth' });
};

const Hero = () => {
  return (
    <section id="accueil" className="relative min-h-[80vh] md:min-h-[90vh] flex items-center overflow-hidden bg-[#01162D]" data-testid="hero-section">
      <div className="absolute inset-0 z-0 diagonal-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-[#01162D] via-[#01162D]/85 to-[#01162D]/30 z-10"></div>
        <img
          src="https://static.prod-images.emergentagent.com/jobs/69eeb90b-b413-4650-9a35-1636c956719e/images/90fd68c0d5fcb6edea256bc7d79fc19f971283488a0ee9febcc2e246f02a1b61.png"
          alt="Chantier menuiserie SMA CONCEPT"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Diagonal blue stripes accent (rappel du visuel logo) */}
      <div className="absolute top-0 right-0 w-1/3 h-full blue-stripes opacity-60 z-10 pointer-events-none hidden md:block"></div>
      <div className="absolute -right-24 top-20 w-[520px] h-4 bg-[#1F6FD6] rotate-[-30deg] z-10 hidden lg:block"></div>
      <div className="absolute -right-32 top-32 w-[520px] h-1 bg-[#3B8BEF] rotate-[-30deg] z-10 hidden lg:block"></div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 py-14 md:py-32 w-full">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-[#1F6FD6]/15 border border-[#3B8BEF]/60 text-white px-4 py-2 rounded-md mb-6 md:mb-8 backdrop-blur-sm animate-fade-in-up">
            <ShieldCheck size={18} className="text-[#3B8BEF]" />
            <span className="text-[11px] md:text-sm font-semibold tracking-[0.15em] md:tracking-[0.2em] uppercase">Certifié RGE · Depuis 2015</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-[1.05] tracking-tight animate-fade-in-up delay-1" data-testid="hero-title">
            SPÉCIALISTE MENUISERIE
            <span className="block text-[#3B8BEF] mt-2">ALU, PVC &amp; BOIS</span>
            <span className="block metal-text">SERRURERIE</span>
          </h1>

          <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8 animate-fade-in-up delay-2">
            <div className="w-10 md:w-16 h-1 bg-[#1F6FD6] flex-shrink-0"></div>
            <p className="text-sm md:text-lg text-[#9FB3CC] font-medium uppercase tracking-[0.1em] md:tracking-[0.25em]">
              Des solutions sur mesure, conçues pour durer
            </p>
          </div>

          <p className="text-base md:text-lg text-[#C9D6E6] mb-8 md:mb-10 leading-relaxed max-w-2xl animate-fade-in-up delay-2">
            Conception, fabrication, pose et SAV en menuiserie métallique et serrurerie. Interventions pour <span className="text-white font-semibold">professionnels &amp; particuliers</span> à Saint-Étienne, dans la Loire et le Lyonnais.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 animate-fade-in-up delay-3">
            <button
              onClick={() => scrollToSection('devis')}
              className="group bg-[#1F6FD6] text-white px-9 py-4 rounded-md font-display font-bold text-base uppercase tracking-wider hover:bg-[#3B8BEF] transition-all duration-300 shadow-xl shadow-[#1F6FD6]/30 flex items-center justify-center gap-3 hover:-translate-y-0.5"
              data-testid="hero-cta-devis"
            >
              Demander un devis
              <ArrowRight size={22} className="group-hover:translate-x-1.5 transition-transform" />
            </button>

            <div className="bg-white/5 backdrop-blur-md border border-white/15 px-6 py-4 rounded-md flex items-center gap-4">
              <div className="w-11 h-11 bg-[#1F6FD6] rounded-md flex items-center justify-center flex-shrink-0">
                <Clock size={22} className="text-white" />
              </div>
              <div>
                <p className="text-white font-bold">Réponse sous 48 h</p>
                <p className="text-[#9FB3CC] text-sm">Devis gratuit, sans engagement</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
